/**
 * B6 (E-2.J.9-01): Email Visual Builder — Component Registry
 *
 * Email-safe subset of Creative Engine components.
 * Single column max 600px. Table layout for Outlook.
 * AI handles email constraints invisibly.
 */

export const EMAIL_COMPONENT_TYPES = [
  "email_header",
  "email_text",
  "email_image",
  "email_button",
  "email_divider",
  "email_footer",
  "email_social",
  "email_product_card",
] as const;

export type EmailComponentType = (typeof EMAIL_COMPONENT_TYPES)[number];

export interface EmailComponentConfig {
  type: EmailComponentType;
  label: string;
  icon: string;
  defaultProps: Record<string, unknown>;
  maxWidth: number; // always 600 for email
}

export const EMAIL_COMPONENT_REGISTRY: EmailComponentConfig[] = [
  {
    type: "email_header",
    label: "Header",
    icon: "heading",
    defaultProps: { text: "Welcome", level: "h1", align: "center", color: "#1a1a1a" },
    maxWidth: 600,
  },
  {
    type: "email_text",
    label: "Text Block",
    icon: "text",
    defaultProps: { text: "", fontSize: 16, lineHeight: 1.6, color: "#333333" },
    maxWidth: 600,
  },
  {
    type: "email_image",
    label: "Image",
    icon: "image",
    defaultProps: { src: "", alt: "", width: 600, align: "center" },
    maxWidth: 600,
  },
  {
    type: "email_button",
    label: "Button",
    icon: "pointer",
    defaultProps: {
      text: "Click Here", href: "", backgroundColor: "#0066cc",
      textColor: "#ffffff", borderRadius: 4, padding: "12px 24px",
    },
    maxWidth: 600,
  },
  {
    type: "email_divider",
    label: "Divider",
    icon: "minus",
    defaultProps: { color: "#e0e0e0", height: 1, margin: "20px 0" },
    maxWidth: 600,
  },
  {
    type: "email_footer",
    label: "Footer",
    icon: "type",
    defaultProps: {
      companyName: "", address: "", unsubscribeText: "Unsubscribe",
      fontSize: 12, color: "#999999",
    },
    maxWidth: 600,
  },
  {
    type: "email_social",
    label: "Social Icons",
    icon: "share2",
    defaultProps: {
      networks: ["facebook", "instagram", "linkedin"],
      iconSize: 32, align: "center",
    },
    maxWidth: 600,
  },
  {
    type: "email_product_card",
    label: "Product Card",
    icon: "shopping-bag",
    defaultProps: {
      name: "", price: "", imageSrc: "", ctaText: "View",
      ctaHref: "", description: "",
    },
    maxWidth: 600,
  },
];
